import pluralize from 'pluralize'
import { HttpClient } from '@opallabs/api'
import { jsonApiWrapper } from '../../jsonApiParser'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const fetchBudget = ({ id, context }) =>
  HttpClient().get(`/budgets/${pluralize.plural(context)}/${id}`)

const getBudget = (options) => (dispatch, getState) =>
  fetchBudget(options)
    .then((response) => {
      const body = response.data
      if (body.data) {
        dispatch(loadJsonApiEntities(body))
        return jsonApiWrapper({
          data: getState().jsonApiEntities.budget[body.data.id],
          state: getState(),
        })
      }

      return {}
    })
    .catch((err) => {
      console.log(err)
      throw err
    })

export default getBudget
